<template>
  <div class="productExperience">
    <!-- 背景图 -->
    <div class="background-image"></div>

    <!-- 中间图片容器 -->
    <div class="images-container">
      <img
          src='../../../assets/productExperience/xh.png'
          class="center-image"
      >
      <img
          src='../../../assets/productExperience/QJ.png'
          class="center-image"
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "productExperience",
  data() {
    return {
      // 清空数据，只保留必要的组件结构
    };
  },
  methods: {
    // 清空所有方法
  }
};
</script>

<style lang="less" scoped>
.productExperience {
  /* 设置容器为全屏 */
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  position: relative;
}

.background-image {
  /* 背景图设置 */
  position: absolute;
  top: 6.5rem;
  left: 0;
  width: 100%;
  height: 100%;
  background: url('../../../assets/productExperience/cpty.png') no-repeat; background-size: 100% 100%;
  z-index: 1;
}

.images-container {
  /* 中间图片容器，居中显示 */
  position: relative;
  z-index: 2;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10vw; /* 两张图片之间的间距 */
  padding: 2rem;
}

.center-image {
  /* 中间图片样式 */
  max-height: 40vh; /* 最大高度为视口高度的40% */
  width: auto;
}

</style>
